export default "__VITE_ASSET__11ab24d3__"